import { IDailyrentBookingCalendarState } from 'shared/store/dailyrentBookingParams/types';

interface ICreateCheckoutPageUrlParams extends Pick<IDailyrentBookingCalendarState, 'dates'> {
  realtyId: number;
  guestsCount?: number;
}

export const createCheckoutPageUrl = ({ realtyId, dates, guestsCount }: ICreateCheckoutPageUrlParams): string => {
  const url = new URL('https://www.cian.ru/dailyrent-checkout/');
  url.searchParams.append('offerId', realtyId.toString());

  if (dates.from && dates.to) {
    url.searchParams.append('checkin', dates.from);
    url.searchParams.append('checkout', dates.to);
  }

  if (guestsCount !== undefined) {
    url.searchParams.append('guestsCount', guestsCount.toString());
  }

  return url.toString();
};
